import { Navigate, Outlet } from "react-router-dom";
import Header from "./header";
import Sidebar from "./sidebar";
import { useAuth } from "~/store";
import { SidebarProvider, useSidebar } from "~/providers/sidebar.provider";

const MainLayoutContent = () => {
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();

  return (
    <div className="flex min-h-dvh bg-[#f2f2f2]">
      <Sidebar />
      <div
        className={`flex-1 transition-all duration-300 ease-in-out ${
          isExpanded || isHovered ? "lg:ml-[290px]" : "lg:ml-[90px]"
        } ${isMobileOpen ? "ml-0" : ""}`}
      >
        <Header />
        <div className="px-4 sm:px-6 lg:px-8 py-6 lg:py-8 bg-[#f2f2f2] min-h-[calc(100vh-4rem)]">
          <div className="bg-[#f2f2f2] border border-[#e5e5e5]">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export const MainLayout = () => {
  const { isAuth } = useAuth();

  if (!isAuth) {
    return <Navigate to="/login" />;
  }

  return (
    <SidebarProvider>
      <MainLayoutContent />
    </SidebarProvider>
  );
};

export default MainLayout;
